import { Stack, useTheme } from "@mui/material";
import { GoalAmountSection } from "web_myplann/Goals/Components/AmountSections/GoalAmountSection";
import { CollapseFadeTransition } from "web_myplann/Goals/Components/CollapseFadeTransition";
import { GoalCategorySelector } from "web_myplann/Goals/Components/GoalCategorySelector";
import { MonthlySavingsConversion } from "web_myplann/Goals/Components/MonthlySavingsConversion";
import { RealizationBox } from "web_myplann/Goals/Components/RealizationBox";
import { useGoalFormPage } from "web_myplann/Goals/Hooks/useGoalFormPage";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { CollapsibleSection } from "web_myplann/Shared/Components/CollapsibleSection";
import { FlatRowFormDatePicker } from "web_myplann/Shared/Components/FlatRow/FlatRowFormDatePicker";
import { FlatRowFormInput } from "web_myplann/Shared/Components/FlatRow/FlatRowFormInput";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import NavigationHeader from "web_myplann/Shared/Header/NavigationHeader";

export const GoalFormPage = () => {
	const theme = useTheme();
	const { t } = useResource();
	const {
		control,
		submit,
		isSubmitting,
		isEdit,
		category,
		selectCategory,
		dueDate,
		savingsTarget,
		realizationMode,
		hasMonthlyHero,
		submitDisabled,
		sectionTitle,
		minDueDate,
		goToList,
	} = useGoalFormPage();

	const submitLabel = isEdit
		? t(Resources.Goals.Form.submitEdit)
		: t(Resources.Goals.Form.submitCreate);

	return (
		<MyPlannLayout
			bgColor={theme.palette.surface.muted}
			disableBottomBarSpacing={realizationMode || hasMonthlyHero}
			disableContentPadding
			topBar={
				<NavigationHeader
					defaultRoute={Routing.Goals.GoalsList}
					title={
						isEdit
							? t(Resources.Goals.Form.titleEdit)
							: t(Resources.Goals.Form.titleCreate)
					}
					bgColor={theme.palette.background.paper}
				/>
			}
		>
			<form onSubmit={submit}>
				<Stack>
					<CollapsibleSection title={t(Resources.Goals.Form.sectionCategory)}>
						<GoalCategorySelector
							value={category}
							onChange={selectCategory}
							disabled={isEdit}
						/>
					</CollapsibleSection>

					<CollapseFadeTransition
						show={Boolean(category)}
						transitionKey={category ?? ""}
					>
						<CollapsibleSection title={t(Resources.Goals.Form.sectionAbout)}>
							<Stack bgcolor={theme.palette.background.paper}>
								<FlatRowFormInput
									control={control}
									name="name"
									label={t(Resources.Goals.Form.nameLabel)}
									placeholder={t(Resources.Goals.Form.namePlaceholder)}
								/>
								<FlatRowFormDatePicker
									control={control}
									name="dueDate"
									label={t(Resources.Goals.Form.dueDateLabel)}
									minDate={minDueDate}
									isLast
								/>
							</Stack>
						</CollapsibleSection>

						<CollapsibleSection title={sectionTitle}>
							<GoalAmountSection control={control} category={category} />
						</CollapsibleSection>

						{realizationMode ? (
							<RealizationBox
								category={category}
								submitLabel={submitLabel}
								cancelLabel={t(Resources.Goals.Form.cancel)}
								submitDisabled={submitDisabled}
								isSubmitting={isSubmitting}
								onCancel={goToList}
							/>
						) : (
							<MonthlySavingsConversion
								savingsTarget={savingsTarget}
								dueDate={dueDate}
								submitLabel={submitLabel}
								cancelLabel={t(Resources.Goals.Form.cancel)}
								submitDisabled={submitDisabled}
								isSubmitting={isSubmitting}
								onCancel={goToList}
							/>
						)}
					</CollapseFadeTransition>
				</Stack>
			</form>
		</MyPlannLayout>
	);
};
